import React, { useEffect, useState } from 'react'
import favicon from "../assets/favicon.png"
import { Helmet } from 'react-helmet'
import { useNavigate } from 'react-router-dom';
import loadingif from "../assets/loading-gif.gif";
import { toast } from 'react-toastify';
import { loginAPI } from '../utils/api';

const Home = () => {
    const [mobile, setMobile] = useState("");
    const [loading, setLoading] = useState(false);
    const navigate = useNavigate();

    const hrid = localStorage.getItem('hrdata');
    useEffect(() => {
        if (hrid) {
            navigate('/dashboard');
        }
        else{
            navigate("/");
        }
    }, [hrid]);

    const NumericOnly = (e) => {
        const reg = /^[0-9\b]+$/
        let preval = e.target.value
        if (e.target.value === '' || reg.test(e.target.value)) setMobile(e.target.value)
        else e.target.value = preval.substring(0, (preval.length - 1))
    }

    const handleLoginSubmit = async (e) => {
        e.preventDefault();
        if (mobile.length === 10) {
            setLoading(true);
            loginAPI("hr-send-mobile-otp", mobile).then((res) => {
                if (res.data.status === 1) {
                    localStorage.setItem("hrmobile", mobile);
                    toast.success(res.data.msg);
                    setLoading(false);
                    navigate("/mobile-otp");
                }
                else {
                    toast.error(res.data.msg);
                }
            })
        }
        else {
            toast.error("Invalid Mobile Number!!");
        }
    }

    return (
        <div className="homePage">
            <Helmet>
                <title>SATKARTAR:HR PANEL::LOGIN</title>
            </Helmet>
            <div className="container h-100">
                <div className="d-flex justify-content-center h-100">
                    <div className="user_card">
                        <div className="d-flex justify-content-center">
                            <div className="brand_logo_container">
                                <img src={favicon} className="brand_logo" alt="Logo" />
                            </div>
                            <h1 className="loginname">HR LOGIN</h1>
                        </div>
                        <div className="d-flex justify-content-center form_container">
                            <form action="/mobile-otp" method="post" onSubmit={handleLoginSubmit}>
                                <div className="mb-3 form-group">
                                    <label htmlFor="hr_mobile">Mobile Number</label>
                                    <input type="text" name="hr_mobile" className="form-control input_user" id="hr_mobile" placeholder="Enter the Mobile Number" required={true} onChange={NumericOnly} />
                                </div>
                                <div className="d-flex justify-content-center mt-3 login_container">
                                    {loading ?
                                        <button disabled={true} type="submit" className="btn login_btn">
                                            <img src={loadingif} alt={loadingif} style={{ width: "7%", marginTop: "-3px" }} /> SENDING...
                                        </button>
                                        :
                                        <button type="submit" className="btn login_btn">SEND MOBILE OTP</button>
                                    }
                                </div>
                            </form>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default Home
